const UPDATE_PROFILE_REQUEST = 'UPDATE_PROFILE_REQUEST';
const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
const UPDATE_PROFILE_FAILURE = 'UPDATE_PROFILE_FAILURE';
const RESET_ADD_COMPONENT_STATUS = 'RESET_ADD_COMPONENT_STATUS';
const SET_PROFILE = 'SET_PROFILE';


export const setProfile = payload => ({
  type: SET_PROFILE,
  payload,
});


export const resetAddComponentStatus = () => ({
  type: RESET_ADD_COMPONENT_STATUS,
});

export const updateProfileRequest = () => ({
  type: UPDATE_PROFILE_REQUEST,
});

export const updateProfileSuccess = payload => ({
  type: UPDATE_PROFILE_SUCCESS,
  payload,
});

export const updateProfileFailure = payload => ({
  type: UPDATE_PROFILE_FAILURE,
  payload,
});

const initialState = {
  isFetched: false,
  fetching: false,
  error: null,
  bio:null,
  file:null
};

export function updateProfile(state = initialState, action) {
  switch (action.type) {
    case SET_PROFILE:
      return {
        ...state,
        bio: action.payload.bio,
        file: action.payload.file
      };
    case RESET_ADD_COMPONENT_STATUS:
      return {
        ...initialState,
      };
    case UPDATE_PROFILE_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        fetching: false,
        isFetched: true,
        componentStatus: action.payload,
      };
    case UPDATE_PROFILE_FAILURE:
      return {
        ...state,
        fetching: false,
        isFetched: false,
        error: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/updateProfile.js